export class ResourcesConstants {
  static readonly Resources = [
    {
      image: "general-settings",
      titleKey: "administration.label.generalSettings",
      descriptionKey: "administration.label.generalSettingsDescription",
      routeUrl: "/general-settings"
    },
    {
      image: "users",
      titleKey: "administration.label.users",
      descriptionKey: "administration.label.userssDescription",
      routeUrl: "/users"
    },
    {
      image: "groups",
      titleKey: "administration.label.userCategories",
      descriptionKey: "administration.label.userCategoriesDescription",
      routeUrl: "/user-categories"
    },
    {
      image: "account-management",
      titleKey: "administration.label.accountManagement",
      descriptionKey: "administration.label.accountManagementDescription",
      routeUrl: "/account-management"
    },
    {
      image: "access-management",
      titleKey: "administration.label.accessManagement",
      descriptionKey: "administration.label.accessManagementDescription",
      routeUrl: "/access-management"
    }
  ]
}